module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-tabs', {
    attrs: {
      "line-width": "24"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "理财师发起"
    }
  }, [_c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao1.png")
    }
  }), _vm._v("\n\t\t\t情况一：套印模式下，理财师发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约确定\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对理财师预约的产品进行预约确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao1.png")
    }
  }), _vm._v("\n\t\t\t情况二：UKEY托管人先签，理财师发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约确定\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对理财师预约的产品进行预约确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.托管人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t等待托管人对合同进行确认签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao1.png")
    }
  }), _vm._v("\n\t\t\t情况三：UKEY托管人后签，理财师发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约确定\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对理财师预约的产品进行预约确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.托管人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t等待托管人对合同进行确认签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])])])]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "投资者发起"
    }
  }, [_c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao1.png")
    }
  }), _vm._v("\n\t\t\t情况一：套印模式下，投资者发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约申请\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者发起预约订单申请\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao1.png")
    }
  }), _vm._v("\n\t\t\t情况二：UKEY托管人先签，投资者发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约申请\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者发起预约订单申请\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.托管人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t等待托管人对合同进行确认签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao1.png")
    }
  }), _vm._v("\n\t\t\t情况三：UKEY托管人后签，投资者发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../common/images/yinhao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约申请\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者发起预约订单申请\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.托管人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t等待托管人对合同进行确认签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50259d59"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/contractStepGuide.vue
// module id = 1052
// module chunks = 1